export default "__VITE_ASSET__B$a$VLNS__"